import { initialState, initialStateByModule } from './state'
import { getAddressByPostalCode } from '@/api/services'

const RESET_ADDRESS = 'resetAddress'
const SET_ADDRESS = 'setAddress'
const CHANGE_ADDRESS_ZIPCODE = 'changeAddressZipcode'
const CHANGE_ADDRESS_STREET_NAME = 'changeAddressStreetName'
const CHANGE_ADDRESS_STREET_NUMBER = 'changeAddressStreetNumber'
const CHANGE_ADDRESS_COMPLEMENT = 'changeAddressComplement'
const CHANGE_ADDRESS_NEIGHBORHOOD = 'changeAddressNeighborhood'
const CHANGE_ADDRESS_CITY = 'changeAddressCity'
const CHANGE_ADDRESS_STATE = 'changeAddressState'

const state = initialStateByModule('address')

const mutations = {
  [RESET_ADDRESS] (state) {
    const initState = initialState.address
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [SET_ADDRESS] (state, payload) {
    Object.assign(state, payload)
  },
  [CHANGE_ADDRESS_ZIPCODE] (state, payload) {
    state.zipcode = payload
  },
  [CHANGE_ADDRESS_STREET_NAME] (state, payload) {
    state.streetName = payload
  },
  [CHANGE_ADDRESS_STREET_NUMBER] (state, payload) {
    state.streetNumber = payload
  },
  [CHANGE_ADDRESS_COMPLEMENT] (state, payload) {
    state.complement = payload
  },
  [CHANGE_ADDRESS_NEIGHBORHOOD] (state, payload) {
    state.neighborhood = payload
  },
  [CHANGE_ADDRESS_CITY] (state, payload) {
    state.city = payload
  },
  [CHANGE_ADDRESS_STATE] (state, payload) {
    state.state = payload
  }
}

const actions = {
  getAddressByPostalCode ({ commit, rootState }, { zipcode }) {
    return getAddressByPostalCode(zipcode)
      .then(res => {
        if (rootState.steps.address === 'finished') return false

        const populateAddress = {
          city: res.data.city,
          complement: '',
          neighborhood: res.data.neighborhood,
          state: res.data.state,
          streetName: res.data.streetName,
          streetNumber: ''
        }

        const data = (!res.data && res.status === 204)
          ? initialState.address
          : populateAddress

        commit(SET_ADDRESS, data)

        return res
      })
      .catch(error => {
        this._vm.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: rootState.product.alias,
            app_step: rootState.steps.currentStep,
            app_errorZone: 'getAddressByPostalCode'
          },
          ctx: {
            label: '[ADDRESS] - getAddressByPostalCode'
          },
          error
        })

        return error
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
